var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('os-report-content-categories-overview',{on:{"rowclicked":(e) => _vm.openExisting(e),"create":function($event){return _vm.openCreateForm()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }